define(function () {
	var IpsModelCollection = require('civicsBase/ipsModelCollection');
	var theModel = require('../models/payment_model');
	const builder = require('civicsUtils/buildUrlParameters');
	const ViewManager = require('civicsUtils/view_manager');

	return IpsModelCollection.extend({
		model: theModel,
		parameters: '',
		urlRoot: '/delegate/civics-api/api/payment/paymenthistories/',
		url: function () {
			var parameters = '';
			if (this.urlParameters != undefined) {
				parameters = builder.buildUrlParameters(this.urlParameters);
			}
			if (!_.isEmpty(this.parameters)) {
				if (parameters.indexOf('?') >= 0) {
					parameters += '&' + this.parameters;
				} else {
					parameters += '?' + this.parameters;
				}
			}
			
			if (parameters.indexOf('?') >= 0) {
				parameters += '&spatialdisabled=true';
			} else {
				parameters += '?spatialdisabled=true';
			}
			
			return this.urlRoot + parameters;
		},
		parse: function (response) {
			var data = response.data;

			//if the collection is supposed to manage the has more records flag, 
			//we need to check for the extra record, and remove the last one.
			if (this.manageHasMoreRecords === true && this.hasMoreRecordsCheckSize == response.data.length) {
				data.pop();
				this.hasMoreRecords = true;
			} else {
				this.hasMoreRecords = false;
			}


			this.methodCodes = {
				'CASH': i18n.t('CIVICS.PAYMENT_HISTORY.METHOD_CASH'),
				'CHECK': i18n.t('CIVICS.PAYMENT_HISTORY.METHOD_CHECK'),
				'CREDIT': i18n.t('CIVICS.PAYMENT_HISTORY.METHOD_CREDIT'),
				'DEBIT': i18n.t('CIVICS.PAYMENT_HISTORY.METHOD_DEBIT'),
				'ESCROW': i18n.t('CIVICS.PAYMENT_HISTORY.METHOD_ESCROW'),
				'MISCELLANEOUS': i18n.t('CIVICS.PAYMENT_HISTORY.METHOD_MISCELLANEOUS'),
			};
			if (ViewManager.globalConfig().get('hasCdrBilling')) {

				this.statusCodes = {
					'APPL': i18n.t('CIVICS.PAYMENT_HISTORY.STATUS_APPLIED'),
					'OVER': i18n.t('CIVICS.PAYMENT_HISTORY.STATUS_OVERPAYMENT'),
					'REVERS': i18n.t('CIVICS.PAYMENT_HISTORY.STATUS_REVERSED'),
					'ALERT': i18n.t('CIVICS.PAYMENT_HISTORY.STATUS_ALERT'),
					'OAPL': i18n.t('CIVICS.PAYMENT_HISTORY.STATUS_OVERAPPLY'),
					'RESOLV': i18n.t('CIVICS.PAYMENT_HISTORY.STATUS_RESOLVE'),
					'UNMATC': i18n.t('CIVICS.PAYMENT_HISTORY.STATUS_UNMATCH'),
					'XFER': i18n.t('CIVICS.PAYMENT_HISTORY.STATUS_TRANSFER'),
				};
			} else {

				this.statusCodes = {
					'A': i18n.t('CIVICS.PAYMENT_HISTORY.STATUS_AWAITING'),
					'P': i18n.t('CIVICS.PAYMENT_HISTORY.STATUS_PAID'),
					'V': i18n.t('CIVICS.PAYMENT_HISTORY.STATUS_VOID'),
				};
			}

			$.each(data, function (index, el) {
				if (el.status && el.status.trim().length > 0) {
					el.statusDesc = this.statusCodes[el.status];
				} else {
					el.statusDesc = i18n.t('CIVICS.PAYMENT_HISTORY.STATUS_UNAPPLY');
				}
				if (el.method && el.method.trim().length > 0) {
					el.methodDesc = this.methodCodes[el.method];
				} else {
					el.methodDesc = "";
				}

				if (!el.feeDescription || !el.feeDescription.trim().length > 0) {
					el.feeDescription = i18n.t('CIVICS.PAYMENT_HISTORY.DEFAULT_ONETIME_PAYMENT_FEE_DESCRIPTION');
				}
			}.bind(this));
			return data;
		}
	});
});
